import { Injectable, Injector } from '@angular/core';
import { BaseState } from 'src/app/common/base/base.state'; import { Action, Selector, State, StateContext } from '@ngxs/store';
import { RadLocationTypeRefresh, RadLocationTypeCreate, RadLocationTypeUpdate, RadLocationTypeDelete } from './rad-location-type.action';
import { RadLocationType } from 'src/app/components/catalogs/rad-monitor/rad-monitor/rad-location-type';
import { RadLocationTypeService } from '../../services/rad-location-type.service';

export class RadLocationTypeStateModel {
  data: RadLocationType[] = [];
}

@State<RadLocationTypeStateModel>({
  name: 'RadLocationType',
  defaults: {
    data: []
  }
})
@Injectable()
export class RadLocationTypeState extends BaseState {
  constructor(
    protected override injector: Injector,
    private radLocationTypeService: RadLocationTypeService

  ) {
    super(injector);
  }

  @Selector()
  static read(state: RadLocationTypeStateModel) {
    return state.data;
  }

  @Action(RadLocationTypeRefresh)
  refresh({ patchState }: StateContext<RadLocationTypeStateModel>) {
    this.radLocationTypeService.GetRadLocationTypes().toPromise().then(data => {
      patchState({ data });
    }).catch(error => {
      console.error(error);
    });
  }

  @Action(RadLocationTypeCreate)
  create({ getState, patchState }: StateContext<RadLocationTypeStateModel>, { item }: RadLocationTypeCreate) {
    patchState({
      data: [...getState().data, item]
    });
  }

  @Action(RadLocationTypeUpdate)
  update({ getState, patchState }: StateContext<RadLocationTypeStateModel>, { id, item }: RadLocationTypeUpdate) {
    const state = getState();
    const index = state.data.findIndex(x => x.id === id);
    const currentState = state.data;

    if (index >= 0) {
      currentState.splice(index, 1, item);
      patchState({ data: currentState });
    }
  }

  @Action(RadLocationTypeDelete)
  delete({ getState, patchState }: StateContext<RadLocationTypeStateModel>, { id }: RadLocationTypeDelete) {
    patchState({
      data: getState().data.filter(x => x.id !== id)
    });
  }
}
